module.exports = __webpack_public_path__ + "static/media/k_of_clubs2.1a1f9a6f.png";